import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    TgButtons2Module,
    TgDateTimeFormatterModule,
    TgGridModule,
    TgIconBasicInfoFramedModule,
    TgIconBasicMinusModule,
    TgIconBasicPlusModule,
    TgInfoBoxModule,
    TgRackModule
} from '@trademe/tangram';
import { ResidentialForSaleAgentSummaryPagePropertyDescriptionSectionModule } from '../../../sections/summary-page-sections/residential-for-sale-agent/summary-page-property-description-section/summary-page-property-description-section.module';
import { ResidentialForSaleSummaryPagePropertyInformationSectionModule } from '../../../sections/summary-page-sections/residential-for-sale/summary-page-property-information-section/summary-page-property-information-section.module';
import { SummaryPageSaleDetailsSectionModule } from '../../../sections/summary-page-sections/residential-for-sale/summary-page-property-sale-details-section/summary-page-sale-details-section.module';
import { SummaryPageAgentContactDetailsSectionModule } from '../../../sections/summary-page-sections/summary-page-agent-contact-details-section/summary-page-agent-contact-details-section.module';
import { SummaryPageOpenHomesSectionModule } from '../../../sections/summary-page-sections/summary-page-open-homes-section/summary-page-open-homes-section.module';
import { SummaryPagePhotosMediaSectionModule } from '../../../sections/summary-page-sections/summary-page-photos-media-section/summary-page-photos-media-section.module';
import { SummaryPageAgentPromotionsSectionModule } from '../../../sections/summary-page-sections/summary-page-agent-promotions-section/summary-page-agent-promotions-section.module';
import { SummaryPageSummarySectionModule } from '../../../sections/summary-page-sections/summary-page-summary-section/summary-page-summary-section.module';
import { SummaryPageValidationSummarySectionModule } from '../../../sections/summary-page-sections/summary-page-validation-summary-section/summary-page-validation-summary-section.module';
import { ResidentialForSaleAgentPropertySummaryPageComponent } from './property-summary-page.component';
import { ResidentialForSaleAgentSummaryPageSummarySectionModule } from '../../../sections/summary-page-sections/residential-for-sale-agent/summary-page-summary-section/summary-page-summary-section.module';

@NgModule({
    imports: [
        CommonModule,
        ResidentialForSaleSummaryPagePropertyInformationSectionModule,
        SummaryPageSaleDetailsSectionModule,
        ResidentialForSaleAgentSummaryPagePropertyDescriptionSectionModule,
        SummaryPagePhotosMediaSectionModule,
        SummaryPageAgentPromotionsSectionModule,
        SummaryPageSummarySectionModule,
        ResidentialForSaleAgentSummaryPageSummarySectionModule,
        SummaryPageValidationSummarySectionModule,
        SummaryPageOpenHomesSectionModule,
        SummaryPageAgentContactDetailsSectionModule,
        TgButtons2Module,
        TgDateTimeFormatterModule,
        TgGridModule,
        TgIconBasicInfoFramedModule,
        TgIconBasicMinusModule,
        TgIconBasicPlusModule,
        TgInfoBoxModule,
        TgRackModule,
        TgRackModule
    ],
    declarations: [ResidentialForSaleAgentPropertySummaryPageComponent],
    exports: [ResidentialForSaleAgentPropertySummaryPageComponent]
})
export class ResidentialForSaleAgentPropertySummaryPageModule {}
